module.exports = "<div class=\"home\">\n  \n  <home-about />\n\n  <home-quote />\n\n  <home-article />\n  \n</div>\n"